module.exports = __webpack_public_path__ + "Roboto-Thin.790ebf41d0214f5eda4e.woff2";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-Thin.woff2
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Thin.woff2
// module chunks = 13